import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './styles.css';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import './App.css';
import Mission from './Mission';
import { Link } from 'react-router-dom';
import Gallery from './Gallery';
import Action from './Action';

export default function App() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLoaded(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <>
      <div className={`relative ${loaded ? 'opacity-100' : 'opacity-0 transition-opacity duration-500 delay-500'}`}>
        <Swiper
          centeredSlides={true}
          autoplay={{
            delay: 5000,
            duration: 5000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper"
          effect="fade"
          grabCursor={true}
          slidesPerView={1}
          loop={true}
          preloadImages={true}
          lazy={true}
          speed={2000}
        >
          <SwiperSlide>
            <img src="images/intro3.jpg" className="swiper-image border border-gray-700" alt="Image Description" />
          </SwiperSlide>

          <SwiperSlide>
            <img src="images/intro2.png" className="swiper-image border border-gray-700" alt="Image Description" />
          </SwiperSlide>
        </Swiper>

        <div className="absolute top-0 left-0 right-0 bottom-10 flex flex-col items-start justify-center z-10">
          {/* <div className="pt-7 text-center mx-4 sm:mx-12">
            <h2 className="py-2 px-2 text-xl sm:text-2xl lg:text-3xl xl:text-xl text-white font-bold leading-tight">~Every child deserves a smile~</h2>
            <Link to="/Donate">
              <button className='px-12 bg-red-600 rounded-md py-2.5 text-black text-xl font-bold transition-transform transform hover:scale-110'>Donate</button>
            </Link>
          </div> */}
        </div>
      </div>

      <div className={`pb-8 flex flex-col items-center justify-center sm:flex-row sm:items-start sm:justify-start bg-green-600 ${loaded ? 'opacity-100 slide-in' : 'opacity-0'}`}>
        <div className='border border-red-400 p-4 bg-gray-600'>
          <div className='border-2 border-gray-400 p-8'>
            <h1 className="text-xl sm:text-2xl font-bold font-home text-white not-italic">SPREAD LOVE</h1>
            <p className='text-start text-base sm:text-base text-gray-200 py-1.5'>Love knows no bounds; let's share it with the world.</p>
          </div>
        </div>

        <div className='border border-red-400 p-4 bg-red-700'>
          <div className='border-2 border-red-400 p-8'>
            <h1 className="text-xl sm:text-2xl font-bold font-home text-white not-italic">STYLE FOR A SMILE</h1>
            <p className='text-start text-base sm:text-base text-gray-200 py-1.5'>Every outfit has a story; let yours be about giving back.</p>
          </div>
        </div>

        <div className='border border-red-400 p-4 bg-blue-800'>
          <div className='border-2 border-blue-500 p-8'>
            <h1 className="text-xl sm:text-2xl font-bold font-home text-white not-italic">SHARE YOUR PLATE</h1>
            <p className='text-start text-base sm:text-base text-gray-200 py-1.5'>You're not just feeding someone's hunger; you're feeding their spirit.</p>
          </div>
        </div>
      </div>
      <Mission />
      <Gallery />
      <Action />
    </>
  );
}
